import Box from '@mui/material/Box'
import { CSSProperties } from 'react'
import { useSearchParams } from 'react-router-dom'

import AnswerLayoutComponent from 'pages/answer/components/answerLayout'
import ShiftAnswerComponent from 'pages/answer/shift/components/shiftAnswer'

export default function ShiftMemberAnswerPage() {
  const [searchParams] = useSearchParams()
  const token = searchParams.get('token')
  if (!token) {
    return <div>URLが不正です</div>
  }

  return (
    <AnswerLayoutComponent title="シフト提出">
      <Box style={containerStyle}>
        <ShiftAnswerComponent token={token} />
      </Box>
    </AnswerLayoutComponent>
  )
}

const containerStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
}
